<div class="ibox detailed-view-ibox">
    <div class="detailed-view-header">
        <span class="building-name">{{itemData.name}}</span>
        <span class="close-detailed-view" (click)="close()">×</span>
    </div>

    <div class="detailed-view-body">
        <div class="detailed-view__more-info">
            <form #form="ngForm" [ngClass]="{'ng-submitted': form.submitted}">
                <div class="row m-t-md m-b-md item-view__header">
                    <div class="col-md-4">
                        <div class="circle-logo">
                            <!--TODO: Add image-->
                        </div>
                    </div>

                    <div class="col-md-8 building-name">
                        <input-field name="buldingName"
                                     [value]="itemData.name"
                                     [class]="'bold height-22-pixel'"
                                     [title]=""
                                     [noEdit]="!itemData.isCanEdit"
                                     [ngModel]="itemData.name"
                                     (update)="update({name: form.value.buldingName})">
                        </input-field>
                        <div class="item-view__description">
                            <p>{{itemData.propertyNumber || '-'}}</p>
                            <p>{{itemData.address || '-'}}</p>
                        </div>
                    </div>
                </div>
<!--                <button type="button" class="btn btn-outline-primary" [routerLink]="['/building-setup/' + itemData.id]">-->
<!--                    Setup building-->
<!--                </button>-->
                <tabs-wrapper-property>
                    <tab-item-property title="Property Info" [id]="'property-info'" [active]="true">
                        <property-info-view *ngIf="itemData.id" [data]="itemData"></property-info-view>
                    </tab-item-property>
                    <tab-item-property title="Services" [id]="'services'">
                        <services-view *ngIf="propertyService.services"
                                       [data]="propertyService.services"
                                       [canEdit]="itemData.isCanEdit"
                                       [ngClass]="{'sk-loading': propertyService.isServiceLoading}"
                                       (onUpdate)="updateServices($event)"
                                       [currentData]="propertyService.currentServices">
                        </services-view>
                    </tab-item-property>
                    <tab-item-property title="Integration" [id]="'integration'">
                        <switch-field
                            [title]="'Luxer One Integration'"
                            name="syncLuxerone"
                            [(ngModel)]="itemData.syncLuxerone"
                            (change)="update({syncLuxerone: form.value.syncLuxerone})"></switch-field>

                        <switch-field
                            [title]="'Snail Integration'"
                            name="snailIntegration"
                            [(ngModel)]="itemData.snailIntegration"
                            (change)="update({snailIntegration: form.value.snailIntegration})"></switch-field>

                        <switch-field
                            [title]="'Parcel One Integration'"
                            name="parcelOneIntegration"
                            [(ngModel)]="itemData.parcelOneIntegration"
                            (change)="update({parcelOneIntegration: form.value.parcelOneIntegration})"></switch-field>

                        <div class="m-t-md" *ngIf="buildingFolder">
                            <hr>

                            <h3>Condomanager</h3>
                            <condomanager [buildingFolder]="buildingFolder" [buildingId]="itemData.id"></condomanager>
                        </div>

                    </tab-item-property>
                </tabs-wrapper-property>
            </form>
        </div>
    </div>
</div>



// WEBPACK FOOTER //
// /app/src/app/views/admin/property/item-view/item-view.component.html